/*
 * Toggles body.header-compact once the visitor scrolls past the header,
 * measures the height difference so the page does not jump, and publishes
 * --sticky-header-bottom so other sticky elements (collection filters) can sit under the header.
 */
(function () {
  var CLASS = 'header-compact';
  var root = document.documentElement;
  var body = document.body;
  var fullHeight = 0;
  var rafId = null;
  var resizeTimer = null;
  var observer = null;

  function setStickyOffset() {
    var group = document.getElementById('header-group');
    if (!group) return;
    root.style.setProperty('--sticky-header-bottom', Math.round(group.getBoundingClientRect().height) + 'px');
  }

  function measure() {
    var group = document.getElementById('header-group');
    var header = document.getElementById('header-component');
    if (!group || !header) return;

    var wasCompact = body.classList.contains(CLASS);

    body.classList.remove(CLASS);
    var full = group.offsetHeight;
    var topRow = header.querySelector('.header__row--top');
    var bottomRow = header.querySelector('.header__row--bottom');
    var topH = topRow ? topRow.offsetHeight : 0;
    var bottomH = bottomRow ? bottomRow.offsetHeight : 0;

    body.classList.add(CLASS);
    var compact = group.offsetHeight;

    if (!wasCompact) body.classList.remove(CLASS);

    fullHeight = full;
    root.style.setProperty('--header-compact-delta', Math.max(0, full - compact) + 'px');
    root.style.setProperty('--header-compact-shift', bottomH ? (bottomH - topH) / 2 + 'px' : '0px');
    setStickyOffset();
  }

  function update() {
    rafId = null;
    var y = window.pageYOffset || root.scrollTop || 0;
    var isCompact = body.classList.contains(CLASS);

    if (!isCompact && y > fullHeight) {
      body.classList.add(CLASS);
      setStickyOffset();
    } else if (isCompact && y <= 10) {
      body.classList.remove(CLASS);
      setStickyOffset();
    }
  }

  function onScroll() {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(update);
  }

  function observeGroup() {
    var group = document.getElementById('header-group');
    if (!group || observer || typeof ResizeObserver === 'undefined') return;
    observer = new ResizeObserver(setStickyOffset);
    observer.observe(group);
  }

  function init() {
    measure();
    update();
    observeGroup();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      measure();
      update();
    }, 150);
  });
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(init);

  init();
})();
